import React from 'react'
import { useLocation } from 'react-router-dom';
import LienzoDiagrama from '../../Components/LienzoDiagrama';


const LienzoScreen = () => {

  const location = useLocation();

  let arrayNodos = [];
  let arrayLineas = [];
  let diagramaId = null;
  let diagramaTitulo = '';
  let diagramaFecha = '';
  let diagramaCole = [];

  if(location.state != null){
    /* console.log(location) */
    /* console.log(location.state.id)
    console.log(location.state.nodosDiagrama)
    console.log(location.state.lineasDiagrama) */
    arrayNodos = location.state.nodosDiagrama;
    arrayLineas = location.state.lineasDiagrama;
    diagramaId = location.state.idDocumento;
    diagramaTitulo = location.state.titulo;
    diagramaFecha = location.state.fecha;
    diagramaCole = location.state.coleccion;
  }else{
    /* console.log('Nuevo diagrama') */
    arrayNodos = [{
        "id":"Nodo-420ac788-1195-464d-8b1f-660bb7f46bb4",
        "text":"Elemento inicial",
        "x":window.innerWidth/2-100,
        "y":window.innerHeight/2-25,
        "isDragging":false,
        "width":200,
        "height":50,
        "fontSize":20,
        "align": 'center',
        "fontStyle":'bold',
        "verticalAlign": 'middle',
        "textFill": '#000000',
        "fill":"#9E9D91",
        "contorno":"#000000",
        "strokeWidth":1,
        "urlImagen": '',
        "imgId": '',
        "imgWidth": 200,
        "imgHeight": 50,
        "tieneImagen": false
    }]
  }
  
  return (
    <div>
        
        <br/>
          <LienzoDiagrama
            arrayNodos={arrayNodos}
            arrayLineas={arrayLineas}
            diagramaId={diagramaId}
            diagramaTitulo={diagramaTitulo}
            diagramaFecha={diagramaFecha}
            diagramaCole={diagramaCole}
          />
    </div>
  )
}

export default LienzoScreen;